module.exports = __webpack_public_path__ + "de833e787c707b42a291803d3ad075c0.glb";